import css from './Card.module.css'

export const styles = {
    card: css['card']
}